import { gql } from 'apollo-angular';
import { Page } from '../../entities/page/page';
import { Label } from '../../entities/label/label';


export const GET_LABELS_PAGED_QUERY = gql`
query getLabelsPaged($filter: LabelFilter, $commandInputs: [CommandInput])
{
  getLabelsPaged: getLabelsPaged(filter: $filter){
    totalPages
    totalElements
    number
    size
    content {
        id
        externalId
        name
        color
        scope
        description
        commands(commandInputs: $commandInputs)
    }
  }
}
`;

export interface GetLabelsPagedResponse {
  loading: boolean;
  getLabelsPaged: Page<Label>;
}
